import type { SVGProps } from 'react'
const SvgChevronDown700 = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="chevron-down-700_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#chevron-down-700_svg__a)">
      <path d="m9 12.113-5.1-5.1 1.65-1.65L9 8.812l3.45-3.45 1.65 1.65z" />
    </g>
  </svg>
)
export default SvgChevronDown700
